import i from "clsx";
import e, { forwardRef as r, useState as S, useRef as q } from "react";
import { useFloating as B, offset as G, arrow as O, size as W, autoUpdate as L, useClick as A, useDismiss as H, useMergeRefs as K, useInteractions as P, FloatingArrow as j } from "@floating-ui/react";
const z = "_button_w29u1_1", U = "_small_w29u1_19", J = "_inline_w29u1_25", Q = "_fullWidth_w29u1_29", V = "_primary_w29u1_34", Y = "_secondary_w29u1_64", Z = "_tertiary_w29u1_91", f = {
  button: z,
  small: U,
  inline: J,
  fullWidth: Q,
  primary: V,
  secondary: Y,
  tertiary: Z
}, ee = "button", te = r(
  ({
    as: t,
    className: n,
    children: o,
    variant: s = "primary",
    size: l = "normal",
    fullWidth: a,
    ...c
  }, d) => {
    const m = t ?? ee;
    return /* @__PURE__ */ e.createElement(
      m,
      {
        type: m === "button" ? "button" : void 0,
        ...c,
        className: i(
          f.button,
          f[s],
          {
            [f.small]: l === "small",
            [f.inline]: !a,
            [f.fullWidth]: a
          },
          n
        ),
        ref: d
      },
      o
    );
  }
);
te.displayName = "Button";
const ne = "_card_wl4rl_1", oe = "_padded_wl4rl_8", se = "_flush_wl4rl_20", le = "_condensed_wl4rl_36", p = {
  card: ne,
  padded: oe,
  "card-group": "_card-group_wl4rl_12",
  flush: se,
  condensed: le
}, ae = "div", ie = r(
  ({
    as: t,
    className: n,
    children: o,
    padded: s = !1,
    ...l
  }, a) => {
    const c = t ?? ae;
    return /* @__PURE__ */ e.createElement(
      c,
      {
        ...l,
        className: i(
          p.card,
          { [p.padded]: s },
          n
        ),
        ref: a
      },
      o
    );
  }
);
ie.displayName = "Card";
const ce = "div", re = r(
  ({
    as: t,
    className: n,
    children: o,
    condensed: s = !1,
    flushOnMobile: l = !1,
    padded: a = !1,
    ...c
  }, d) => {
    const m = t ?? ce;
    return /* @__PURE__ */ e.createElement(
      m,
      {
        ...c,
        className: i(
          p["card-group"],
          {
            [p.flush]: l,
            [p.condensed]: s,
            [p.padded]: a
          },
          n
        ),
        ref: d
      },
      o
    );
  }
);
re.displayName = "CardGroup";
const de = "_timeline_ckebo_1", _ = {
  timeline: de,
  "timeline-list-item": "_timeline-list-item_ckebo_7",
  "timeline-node-line": "_timeline-node-line_ckebo_11",
  "timeline-node": "_timeline-node_ckebo_11",
  "timeline-node-period": "_timeline-node-period_ckebo_24",
  "timeline-child-container": "_timeline-child-container_ckebo_39"
}, me = r(
  ({ className: t, children: n, ...o }, s) => /* @__PURE__ */ e.createElement("ol", { className: i(_.timeline, t), ref: s, ...o }, n)
);
me.displayName = "Timeline";
const _e = r(
  ({ children: t, ...n }, o) => /* @__PURE__ */ e.createElement("li", { className: _["timeline-list-item"], ref: o, ...n }, /* @__PURE__ */ e.createElement("div", { className: _["timeline-node"] }, /* @__PURE__ */ e.createElement("span", { className: _["timeline-node-period"] }), /* @__PURE__ */ e.createElement("span", { className: _["timeline-node-line"] })), /* @__PURE__ */ e.createElement("div", { className: _["timeline-child-container"] }, t))
);
_e.displayName = "TimelineItem";
const pe = "_tag_1x9g6_1", ue = "_notification_1x9g6_11", D = {
  tag: pe,
  notification: ue
}, fe = r(
  ({ variant: t = "notification", className: n, children: o, ...s }, l) => /* @__PURE__ */ e.createElement(
    "strong",
    {
      className: i(D.tag, D[t], n),
      ref: l,
      ...s
    },
    o
  )
);
fe.displayName = "Tag";
const E = {
  XXS: 4,
  XS: 8,
  SM: 12,
  MD: 16,
  LG: 24,
  XL: 32,
  XXL: 40
}, ye = "_dropdown_qb7e7_1", ge = "_title_qb7e7_12", we = "_body_qb7e7_25", Ee = "_padded_qb7e7_31", y = {
  dropdown: ye,
  title: ge,
  body: we,
  padded: Ee
}, be = "div", Ne = r(
  ({
    as: t,
    children: n,
    triggerEl: o,
    title: s,
    padded: l = !1,
    verticalOffset: a = "XS",
    ...c
  }, d) => {
    const m = t ?? be, [b, g] = S(!1), N = q(null), { refs: h, strategy: k, x, y: R, context: w } = B({
      open: b,
      onOpenChange: g,
      placement: "bottom-start",
      strategy: "absolute",
      middleware: [
        G({
          mainAxis: E[a]
        }),
        O({
          element: N
        }),
        W({
          padding: E.MD,
          apply({ availableWidth: u, elements: C, middlewareData: I }) {
            Object.assign(C.floating.style, {
              width: `${u}px`,
              maxHeight: `${window.innerHeight - C.reference.getBoundingClientRect().bottom - (I.offset?.y ?? 0) - E.MD}px`
            });
          }
        })
      ],
      whileElementsMounted: L
    }), v = A(w), X = H(w), $ = K([h.setFloating, ...d ? [d] : []]), { getFloatingProps: M, getReferenceProps: T } = P([
      v,
      X
    ]), F = (u) => {
      u.key === "Enter" && g(!1);
    };
    return /* @__PURE__ */ e.createElement(e.Fragment, null, o({ refs: h, getReferenceProps: T }), b ? /* @__PURE__ */ e.createElement(
      m,
      {
        ...c,
        className: i(y.dropdown),
        ref: $,
        style: {
          position: k,
          top: R ?? 0,
          left: x ?? 0
        },
        ...M()
      },
      s ? /* @__PURE__ */ e.createElement(
        "span",
        {
          className: i(y.title),
          onClick: () => g(!1),
          onKeyDown: (u) => F(u),
          role: "button",
          tabIndex: 0
        },
        s
      ) : null,
      /* @__PURE__ */ e.createElement(
        "div",
        {
          className: i(y.body, { [y.padded]: l })
        },
        n
      ),
      /* @__PURE__ */ e.createElement(
        j,
        {
          context: w,
          fill: "#ECECEC",
          ref: N,
          stroke: "#999",
          strokeWidth: 1
        }
      )
    ) : null);
  }
);
Ne.displayName = "Dropdown";
export {
  te as Button,
  ie as Card,
  re as CardGroup,
  Ne as Dropdown,
  fe as Tag,
  me as Timeline,
  _e as TimelineItem
};
